import React, { Component } from 'react';
import http from '../modules/api';

import SelectBoxV2 from '../modules/common/SelectBoxV2';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';

class InstagramCreateCntSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      /**
      <option value="1">1개</option>
      <option value="2">2개</option>
      <option value="5">5개 (권장)</option>
      <option value="10">10개</option>
      <option value="20">20개</option>
      <option value="30">30개 (최대)</option> 
       */
      hashtag_count_list: [
        { value: 1, label: '1개' },
        { value: 2, label: '2개' },
        { value: 3, label: '3개' },
        { value: 4, label: '4개' },
        { value: 5, label: '5개 (권장)' },
        // { value: 10, label: '10개' },
        // { value: 20, label: '20개' },
        // { value: 30, label: '30개 (최대)' },
      ],

      /**
      <option value="1">1개</option>
      <option value="2">2개</option>
      <option value="3">3개</option>
      <option value="4">4개</option>
      <option value="5">5개</option>
      <option value="6">6개</option>
      */
      feed_caption_auto_created_count_list: [
        { value: 1, label: '1개' },
        { value: 2, label: '2개' },
        { value: 3, label: '3개' },
        { value: 4, label: '4개' },
        { value: 5, label: '5개' },
        { value: 6, label: '6개' },
      ],

      manual_is_auto_hashtag_on: false,
      manual_hashtag_count: 5,
      manual_caption_count: 3,

      auto_is_auto_hashtag_on: false,
      auto_hashtag_count: 5,
      auto_caption_count: 1,

      /* 로딩, 저장 다이얼로그 */
      save_dialog_show_state: false,
      save_dialog_content: "로딩중 입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn:"N" }],
    };
  }

  componentDidMount() {
    this.loadGenerationCount();
  }

  handleManualToggleSwitch = () => {
    this.setState((prevState) => ({
      manual_is_auto_hashtag_on: !prevState.manual_is_auto_hashtag_on,
    }));
  };
  handleAutoToggleSwitch = () => {
    this.setState((prevState) => ({
      auto_is_auto_hashtag_on: !prevState.auto_is_auto_hashtag_on,
    }));
  };

  onChangeManualHashtagCnt = (ext, value) => {
    this.setState({ manual_hashtag_count: value });
  };
  onChangeManualFeedCaptionCnt = (text, value) => {
    this.setState({ manual_caption_count: value });
  };
  onChangeAutoHashtagCnt = (ext, value) => {
    this.setState({ auto_hashtag_count: value });
  };
  onChangeAutoFeedCaptionCnt = (text, value) => {
    this.setState({ auto_caption_count: value });
  };

  // 데이터 조회
  loadGenerationCount = () => {
    http.get('/rest/shop/instagram/generation-count')
      .then(response => {
        const data = (response && response.data && response.data.result) ? response.data.result : {};

        this.setState({
          manual_hashtag_count: data.manual_hashtag_count || 5,
          manual_caption_count: data.manual_caption_count || 3,
          manual_is_auto_hashtag_on: data.manual_is_auto_hashtag_on !== undefined ? !!data.manual_is_auto_hashtag_on : false,

          auto_hashtag_count: data.auto_hashtag_count || 5,
          auto_caption_count: data.auto_caption_count || 1,
          auto_is_auto_hashtag_on: data.auto_is_auto_hashtag_on !== undefined ? !!data.auto_is_auto_hashtag_on : false,
        });
      })
      .catch(error => {
        console.error("데이터 조회 에러:", error);
      });
  };

  // 데이터 저장
  saveGenerationCount = () => {
    this.setState({
      save_dialog_show_state: true,
      save_dialog_content: "저장중 입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    const payload = {
      manual_hashtag_count: this.state.manual_hashtag_count,
      manual_caption_count: this.state.manual_caption_count,
      manual_is_auto_hashtag_on: this.state.manual_is_auto_hashtag_on ? 1 : 0,

      auto_hashtag_count: this.state.auto_hashtag_count,
      auto_caption_count: 1,
      auto_is_auto_hashtag_on: this.state.auto_is_auto_hashtag_on ? 1 : 0
    };

    http.post('/rest/shop/instagram/generation-count', payload)
      .then(response => {
        this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "저장되었습니다.",
          save_dialog_button_list: [
            {
              title: "확인",
              type: "1",
              event_method: () => {
                this.setState({ save_dialog_show_state: false });
              }
            }
          ],
        });

        if (window.opener) {
          window.opener.postMessage(
            { type: "cnt_setting_saved", result: true },
            window.location.origin
          );
        }
      })
      .catch(error => {
        console.error("데이터 저장 에러:", error);

        this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "저장에 실패했습니다.",
          save_dialog_button_list: [
            {
              title: "확인",
              type: "1",
              event_method: () => {
                this.setState({ save_dialog_show_state: false });
              }
            }
          ],
        });
      });
  };

  render() {
    const { hashtag_count_list, feed_caption_auto_created_count_list, manual_is_auto_hashtag_on, auto_is_auto_hashtag_on, manual_hashtag_count, auto_hashtag_count, manual_caption_count, auto_caption_count, save_dialog_show_state, save_dialog_content, save_dialog_button_list } = this.state;

    return (
      <>
        <div className="main-wrapper instagram_create_cnt_setting_page" id="page-wrapper" style={{ height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f3f4f6', fontFamily: "'Noto Sans KR', sans-serif" }}>
          <div className="robo-md-container">
            <style>{`
              .instagram_create_cnt_setting_page {
                  --primary-mint: #00e2e6;
                  --primary-mint-hover: #00bfc2;
                  --deep-navy: #0A1A2F;
                  --deep-navy-hover: #111C3A;
                  --bg-color: #f4f7f9; 
                  --border-color: #e5e7eb;
                  --text-main: #0A1A2F;
                  --text-sub: #6b7280;
                  --white: #ffffff;
                  --radius-md: 12px;
                  --radius-sm: 8px;
              }
              .instagram_create_cnt_setting_page { padding-top: 72px !important;  max-width: 100% !important;}
              /* Base Styles */
              .robo-md-container * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Noto Sans KR', sans-serif; }
              .robo-md-container { background-color: #f4f7f9; color: #0A1A2F; display: flex; min-height: 100vh; }
              /* Layout */
              .robo-md-container .sidebar { width: 260px; background: white; border-right: 1px solid #e5e7eb; padding: 32px 20px; display: flex; flex-direction: column; }
              .robo-md-container .main-content { flex: 1; padding: 40px; max-width: 900px; margin: 0 auto; width: 100%; }
              /* Sidebar Elements */
              .robo-md-container .brand-logo { font-size: 24px; font-weight: 700; color: #0A1A2F; margin-bottom: 40px; padding-left: 12px; display: flex; align-items: center; gap: 10px; }
              .robo-md-container .brand-icon { width: 32px; height: 32px; background: #00e2e6; color: #0A1A2F; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 16px; }
              .robo-md-container .menu-group-title { font-size: 12px; color: #6b7280; font-weight: 600; margin-bottom: 12px; padding-left: 12px; }
              .robo-md-container .menu-item { padding: 14px 16px; border-radius: 8px; cursor: pointer; color: #6b7280; font-weight: 600; font-size: 15px; margin-bottom: 8px; transition: all 0.2s; display: flex; align-items: center; gap: 12px; }
              .robo-md-container .menu-item:hover { background: rgba(0, 226, 230, 0.05); color: #0A1A2F; }
              .robo-md-container .menu-item.active { background: rgba(0, 226, 230, 0.1); color: #0A1A2F; border-left: 4px solid #00e2e6; }
              /* Content Elements */
              .robo-md-container .page-title { font-size: 28px; font-weight: 700; margin-bottom: 8px; color: #0A1A2F; }
              .robo-md-container .page-subtitle { font-size: 15px; color: #6b7280; margin-bottom: 32px; line-height: 1.5; }
              /* Cards */
              .robo-md-container .card { background: white; border: 1px solid #e5e7eb; border-radius: 12px; padding: 28px; margin-bottom: 24px; box-shadow: 0 2px 8px rgba(10, 26, 47, 0.04); }
              .robo-md-container .card-title { font-size: 18px; font-weight: 700; margin-bottom: 24px; display: flex; align-items: center; gap: 8px; border-bottom: 2px solid #f9fafb; padding-bottom: 16px; }
              .robo-md-container .card-sub-title { font-size: 16px; font-weight: 700; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; }
              /* Form Controls */
              .robo-md-container .form-group { margin-bottom: 24px; }
              .robo-md-container .m-b-24 { margin-bottom: 24px; }
              .robo-md-container .form-label { display: block; font-weight: 600; font-size: 14px; margin-bottom: 8px; color: #0A1A2F; }
              .robo-md-container .form-desc { font-size: 13px; color: #6b7280; margin-bottom: 12px; line-height: 1.5; }
              .robo-md-container .form-control { width: 100%; padding: 12px 16px; border: 2px solid #e5e7eb; border-radius: 8px; font-size: 14px; transition: all 0.2s; background: white; color: #0A1A2F; appearance: auto; }
              .robo-md-container .form-control:focus { outline: none; border-color: #00e2e6; box-shadow: 0 0 0 3px rgba(0, 226, 230, 0.1); }
              /* Radio & Checkbox Groups */
              .robo-md-container .radio-group { display: flex; flex-direction: column; gap: 12px; }
              .robo-md-container .radio-group.horizontal { flex-direction: row; flex-wrap: wrap; }
              .robo-md-container .radio-label { display: flex; align-items: center; gap: 10px; cursor: pointer; padding: 14px 16px; border: 2px solid #e5e7eb; border-radius: 8px; background: white; transition: all 0.2s; flex: 1; }
              .robo-md-container .radio-label:hover { border-color: #00e2e6; }
              .robo-md-container .radio-label input[type="radio"] { width: 18px; height: 18px; accent-color: #00e2e6; }
              .robo-md-container .radio-label .text-main { font-weight: 600; font-size: 14px; color: #0A1A2F; }
              .robo-md-container .radio-label .text-sub { font-size: 12px; color: #6b7280; margin-top: 4px; line-height: 1.4; }
              /* Toggle Switch */
              .robo-md-container .toggle-row { display: flex; justify-content: space-between; align-items: center; padding: 16px; background: #f9fafb; border-radius: 8px; margin-bottom: 16px; cursor: pointer; }
              .robo-md-container .toggle-info { padding-right: 16px; }
              .robo-md-container .toggle-info strong { display: block; font-size: 15px; color: #0A1A2F; margin-bottom: 4px; }
              .robo-md-container .toggle-info span { font-size: 13px; color: #6b7280; line-height: 1.4; display: block; }
              .robo-md-container .toggle-switch { position: relative; width: 52px; height: 28px; background: #00e2e6; border-radius: 14px; transition: all 0.3s; flex-shrink: 0; }
              .robo-md-container .toggle-switch.off { background: #d1d5db; }
              .robo-md-container .toggle-knob { position: absolute; top: 3px; width: 22px; height: 22px; background: white; border-radius: 50%; transition: all 0.3s; box-shadow: 0 2px 4px rgba(0,0,0,0.1); right: 3px; }
              .robo-md-container .toggle-switch.off .toggle-knob { left: 3px; right: auto; }
              /* line */
              .robo-md-container .line { border-bottom: 2px solid #f9fafb; margin-top: 10px; margin-bottom: 24px; }
              /* Buttons */
              .btn {
                  height: 42px;
                  padding: 0 20px;
                  border-radius: var(--radius-sm);
                  font-size: 14px;
                  font-weight: 700;
                  cursor: pointer;
                  border: none;
                  transition: 0.2s;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  gap: 6px;
                  white-space: nowrap;
              }
              .btn:focus {
                box-shadow: 0 0 0 0 transparent !important;
              }
              .robo-md-container .btn-container { display: flex; justify-content: flex-end; gap: 12px; margin-top: 32px; padding-top: 24px; border-top: 1px solid #e5e7eb; }
              .robo-md-container .btn { padding: 12px 24px; border-radius: 8px; font-size: 15px; font-weight: 600; cursor: pointer; border: none; transition: all 0.2s; }
              .robo-md-container .btn-outline { background: #FFF; border: 1px solid #d1d5db; color: #4b5563; }
              .robo-md-container .btn-outline:hover { background: #f3f4f6; border-color: #00e2e6; color: #0A1A2F; }
              .robo-md-container .btn-primary { 
                background: #00e2e6;
                color: #4b5563;
                box-shadow: 0 2px 8px rgba(0, 226, 230, 0.2);
              }
              .robo-md-container .btn-primary:hover {
                background: #00bfc2;
                color: #4b5563;
                transform: translateY(-1px);
              }
              /* Grid Layouts & Sections */
              .robo-md-container .grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
              .robo-md-container .settings-section { display: none; animation: fadeIn 0.3s ease; }
              .robo-md-container .settings-section.active { display: block; }
              @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
              /* Responsive */
              @media (max-width: 768px) {
                .robo-md-container { flex-direction: column; }
                .robo-md-container .sidebar { width: 100%; border-right: none; border-bottom: 1px solid #e5e7eb; padding: 20px; flex-direction: row; flex-wrap: wrap; align-items: center; gap: 16px; }
                .robo-md-container .brand-logo { margin-bottom: 0; width: 100%; padding-left: 0; }
                .robo-md-container .menu-group-title { display: none; }
                .robo-md-container .menu-item { margin-bottom: 0; padding: 10px 14px; font-size: 14px; flex: 1; justify-content: center; }
                .robo-md-container .main-content { padding: 24px 20px; }
                .robo-md-container .grid-2 { grid-template-columns: 1fr; }
                .robo-md-container .radio-group.horizontal { flex-direction: column; }
                .robo-md-container .toggle-row { flex-direction: column; align-items: flex-start; gap: 16px; }
                .robo-md-container .btn-container { flex-direction: column; }
                .robo-md-container .btn { width: 100%; padding: 14px; }
              }
            `}</style>

            <main className="main-content">
              <div className={`settings-section active`}>
                <h1 className="page-title">AI 자동 환경설정</h1>
                <p className="page-subtitle">인스타그램 피드 및 해시태그 자동화 동작의 기본 수량과 방식을 설정합니다.</p>

                <div data-instagram-tutorial="env-manual-section">
                <div className="card-sub-title">게시물 등록 환경설정</div>
                <div className="card">
                  <div className="card-title">기본 수량 및 옵션 설정</div>
                  <div className="toggle-row" data-instagram-tutorial="env-manual-hashtag-toggle" onClick={this.handleManualToggleSwitch}>
                    <div className="toggle-info">
                      <strong>해시태그 자동 생성 여부</strong>
                      <span>피드 문구를 제작할 때 자동으로 해시태그를 함께 생성합니다.</span>
                    </div>
                    <div className={`toggle-switch ${!manual_is_auto_hashtag_on ? 'off' : ''}`}>
                      <div className="toggle-knob"></div>
                    </div>
                  </div>
                  <div className="grid-2">
                    {/* <div className="form-group"> */}
                    <div className="m-b-24" data-instagram-tutorial="env-manual-hashtag-count">
                      <label className="form-label">해시태그 자동생성 개수</label>
                      {/* <select className="form-control" defaultValue="5">
                        <option value="1">1개</option>
                        <option value="2">2개</option>
                        <option value="5">5개 (권장)</option>
                        <option value="10">10개</option>
                        <option value="20">20개</option>
                        <option value="30">30개 (최대)</option>
                      </select> */}
                      <SelectBoxV2
                          id="hashTagCntSelectBox"
                          width="100%"
                          height="42px"
                          list={hashtag_count_list || []}
                          optionTexttName="label"
                          optionValuetName="value"
                          selectedValue={manual_hashtag_count || "1"}
                          onClickOption={this.onChangeManualHashtagCnt}
                      />
                    </div>
                    {/* <div className="form-group"> */}
                    <div className="m-b-24" data-instagram-tutorial="env-manual-caption-count">
                      <label className="form-label">피드문구 자동생성 개수</label>
                      {/* <select className="form-control" defaultValue="3">
                        <option value="1">1개</option>
                        <option value="2">2개</option>
                        <option value="3">3개</option>
                        <option value="4">4개</option>
                        <option value="5">5개</option>
                        <option value="6">6개</option>
                      </select> */}
                      <SelectBoxV2
                          id="feedCaptionAutoCreateCntSelectBox"
                          width="100%"
                          height="42px"
                          list={feed_caption_auto_created_count_list || []}
                          optionTexttName="label"
                          optionValuetName="value"
                          selectedValue={manual_caption_count || "1"}
                          onClickOption={this.onChangeManualFeedCaptionCnt}
                      />
                    </div>
                  </div>
                </div>
                </div>


                <div data-instagram-tutorial="env-auto-section">
                <div className="card-sub-title">콘텐츠 자동화 환경설정</div>
                <div className="card">
                  <div className="card-title">기본 수량 및 옵션 설정</div>
                  <div className="toggle-row" onClick={this.handleAutoToggleSwitch}>
                    <div className="toggle-info">
                      <strong>해시태그 자동 생성 여부</strong>
                      <span>피드 문구를 제작할 때 자동으로 해시태그를 함께 생성합니다.</span>
                    </div>
                    <div className={`toggle-switch ${!auto_is_auto_hashtag_on ? 'off' : ''}`}>
                      <div className="toggle-knob"></div>
                    </div>
                  </div>

                  <div className="grid-2">
                    {/* <div className="form-group"> */}
                    <div className="m-b-24">
                      <label className="form-label">해시태그 자동생성 개수</label>
                      {/* <select className="form-control" defaultValue="5">
                        <option value="1">1개</option>
                        <option value="2">2개</option>
                        <option value="5">5개 (권장)</option>
                        <option value="10">10개</option>
                        <option value="20">20개</option>
                        <option value="30">30개 (최대)</option>
                      </select> */}
                      <SelectBoxV2
                          id="hashTagCntSelectBox"
                          width="100%"
                          height="42px"
                          list={hashtag_count_list || []}
                          optionTexttName="label"
                          optionValuetName="value"
                          selectedValue={auto_hashtag_count || "1"}
                          onClickOption={this.onChangeAutoHashtagCnt}
                      />
                    </div>
                    {/* <div className="form-group"> */}
                    <div className="m-b-24">
                      <label className="form-label">피드문구 자동생성 개수</label>
                      {/* <select className="form-control" defaultValue="3">
                        <option value="1">1개</option>
                        <option value="2">2개</option>
                        <option value="3">3개</option>
                        <option value="4">4개</option>
                        <option value="5">5개</option>
                        <option value="6">6개</option>
                      </select> */}
                      <SelectBoxV2
                          id="feedCaptionAutoCreateCntSelectBox"
                          width="100%"
                          height="42px"
                          list={feed_caption_auto_created_count_list || []}
                          optionTexttName="label"
                          optionValuetName="value"
                          selectedValue={auto_caption_count || "1"}
                          onClickOption={this.onChangeAutoFeedCaptionCnt}
                          disabled = {true}
                      />
                      <span style={{fontSize: "11px", color: "#6b7280"}}>* 자동 게시 시에는 문장 1개만 사용됩니다.</span>
                    </div>
                  </div>
                </div>
                </div>

                <div className="btn-container" data-instagram-tutorial="env-save">
                  <button className="btn btn-outline" onClick={() => {this.loadGenerationCount()}} tabIndex={-1}>초기화</button>
                  <button className="btn btn-primary" onClick={() => {this.saveGenerationCount()}} tabIndex={-1}>변경사항 저장</button>
                </div>
              </div>
            </main>
          </div>
        </div>

        {/* 로딩, 저장 다이얼로그 */
            this.state.save_dialog_show_state === true &&
            <SaveDialogV2
                content={this.state.save_dialog_content}
                button_list={this.state.save_dialog_button_list}
            />
        }
      </>
    );
  }
}

export default InstagramCreateCntSetting;